export default "__VITE_ASSET__CWWQnYSN__"